<template>
  <div class="t-faq">
    <div class="t-lk-container">
      <h1 class="t-lk-title t-lk-container-mobile">{{ $root.staticText.lk.faqTitle }}</h1>
      <div class="t-faq__container">
        <div class="t-faq__left">
          <template v-for="(item, index) in faq">
            <div v-animation:bottom.delay class="t-faq__item" :class="{ '_bottom-mobile': item.link }">
              <h2 class="t-faq__title">{{ item.title }}</h2>
              <div class="t-faq__wrap">
                <div class="t-faq__content">
                  <div class="t-faq__desc">{{ item.description }}</div>
                  <router-link v-if="item.link" :to="item.link" class="t-btn-green t-faq__btn">
                    {{ $root.staticText.lk.faqAll }}
                  </router-link>
                </div>
                <div class="t-faq__questions">
                  <router-link :to="question.link" class="t-faq__question" v-for="question in item.questions" :key="question.id">
                    {{ question.name }}
                  </router-link>
                </div>
              </div>
            </div>

            <banner-native-cmp
              v-if="isMobile && index === 0 && banner"
              v-animation:bottom.delay
              :banner="banner"
              class="t-faq__banner"
            >
            </banner-native-cmp>
          </template>

          <load-more-cmp
            v-if="pagination"
            :pagination="pagination"
            :btn="$root.staticText.lk.loadMore"
            class="t-faq__more"
            :disabled-btn="disableLoadMore"
          >
          </load-more-cmp>
        </div>
        <div v-if="!isMobile" v-animation:bottom.delay class="t-faq__right">
          <banner-native-cmp v-if="banner" :banner="banner" :is-vertical="true"></banner-native-cmp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import loadMore from '@components/ui-components/load-more/load-more.vue'
import bannerNative from '@components/lk/banner-native/banner-native.vue'
import { mapState } from 'vuex'
import { router } from '@src/routes'

export default {
  name: 'lk-faq',
  data() {
    return {
      faq: null,
      banner: null,
      pagination: null,
      disableLoadMore: false,
    }
  },
  components: {
    'load-more-cmp': loadMore,
    'banner-native-cmp': bannerNative,
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  methods: {
    setData(data) {
      this.faq = data.items
      this.banner = data.banner
      this.pagination = data.pagination
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.loadMore) {
      this.disableLoadMore = true
      let url = process.env.NODE_ENV !== 'production' ? 'lk/faq.json' : to.path.substring(1).replace(router.history.base, '')

      Vue.http.get(url, { params: to.query }).then(
        data => {
          next()
          this.faq = this.faq.concat(data.data.items)
          this.pagination = data.data.pagination
          this.disableLoadMore = false
        },
        () => {
          this.disableLoadMore = false
          next('/404')
        }
      )
    } else {
      next()
    }
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/faq.json' : to.path.substring(1).replace(router.history.base, '')

    Vue.http.get(url).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/faq/index.vue